//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular, {IHttpService, IPromise} from 'angular';

export interface IUserInfoDto {
  id: number;
  firstName: string;
  lastName: string;
}

export default class CoreApiService {
  constructor(
        private $http: IHttpService,
        private promiseService,
    ) {}

  public getUsersAsync(): IPromise<IUserInfoDto> {
    return this.promiseService.processHttpResponse(this.$http.get(`/api/users`)).then((response) => {
      return response as IUserInfoDto[];
    });
  }
}

angular.module('curalate').service('CoreApiService', [
  '$http',
  'PromiseService',
  CoreApiService,
]);
